/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiProjectSettingKeyFromJSON, ApiProjectSettingKeyToJSON, } from './ApiProjectSettingKey';
export function ApiProjectSettingFromJSON(json) {
    return ApiProjectSettingFromJSONTyped(json, false);
}
export function ApiProjectSettingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'appliedAt': !exists(json, 'appliedAt') ? undefined : (new Date(json['appliedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : ApiProjectSettingKeyFromJSON(json['key']),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiProjectSettingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'appliedAt': value.appliedAt === undefined ? undefined : (value.appliedAt.toISOString()),
        'id': value.id,
        'key': ApiProjectSettingKeyToJSON(value.key),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'value': value.value,
    };
}
